import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewportScroller } from '@angular/common';
import { Component, HostListener, OnInit, inject } from '@angular/core';

@Component({
  selector: 'app-tab-to-top',
    imports: [CommonModule, TranslateModule, RouterModule, ReactiveFormsModule, FormsModule, NgSelectModule, NgScrollbarModule, NgbModule],
    templateUrl: './tab-to-top.component.html',
    styleUrls: ['./tab-to-top.component.scss']
})
export class TabToTopComponent implements OnInit {
  private viewScroller = inject(ViewportScroller);

  public show: boolean = false;

  /** Inserted by Angular inject() migration for backwards compatibility */


  constructor() { }

  ngOnInit(): void {
  }
  @HostListener("window:scroll", [])
  onWindowScroll(){
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if(number > 400){
      this.show = true;
    } else {
      this.show = false;
    }
  }

  taptotop(){
    this.viewScroller.scrollToPosition([0,0]);
  }
}
